import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      dark: {
        primary: '#F47920',
        secondary: '#444444',
        surface: '#444444',

        info: '#77A8DA',
        error: '#F44336',
        success: '#4EA96D',
        warning: '#FCCC4A',
        accent: '#607d8b',

        'custom-primary': '#F47920',
        'custom-secondary': '#5d7783',
        'custom-surface': '#191919'
      }
    },
    dark: true,
    options: {
      customProperties: true
    }
  }
});
